import { api } from '../api.js';
import { worstFeverZone } from '../utils/ccpm.js';
import { feverEmoji } from '../utils/format.js';

function formatRubShort(n) {
  if (!n) return '0';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace('.0', '') + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace('.0', '') + 'к';
  return String(Math.round(n));
}

export async function initStatsBar() {
  const bar = document.getElementById('stats-bar');
  if (!bar) return;

  bar.innerHTML = `
    <span>Неделя: <strong id="stat-week">—</strong></span>
    <span>WIP: <strong id="stat-wip">—</strong></span>
    <span>В работе: <strong id="stat-active">—</strong></span>
    <span>Готово: <strong id="stat-revenue">—</strong> ₽</span>
    <span>Сегодня: <strong id="stat-due-today">—</strong></span>
    <span>Просрочено: <strong id="stat-overdue">—</strong></span>
    <span>Fever: <strong id="stat-fever">—</strong></span>
  `;

  try {
    const [wip, capacity, feverData, sub] = await Promise.all([
      api.stats.wip(),
      api.stats.weeklyCapacity(),
      api.stats.feverChart(),
      api.stats.personalSubstats().catch(() => null),
    ]);

    const weekEl   = document.getElementById('stat-week');
    const wipEl    = document.getElementById('stat-wip');
    const activeEl = document.getElementById('stat-active');
    const feverEl  = document.getElementById('stat-fever');

    if (weekEl)   weekEl.textContent   = capacity?.total_hours ? `${capacity.total_hours}ч` : '—';
    if (wipEl) {
      wipEl.textContent = `${wip?.current ?? '—'}/${wip?.limit ?? 3}`;
      const cur = Number(wip?.current);
      const lim = Number(wip?.limit ?? 3);
      if (Number.isFinite(cur) && Number.isFinite(lim) && cur > lim) {
        wipEl.classList.add('stat-over-limit');
        wipEl.title = `Лимит WIP превышен: ${cur} задач в работе при пределе ${lim}`;
      } else {
        wipEl.classList.remove('stat-over-limit');
        wipEl.title = '';
      }
    }
    if (activeEl) activeEl.textContent = wip?.current ?? '—';

    const revEl = document.getElementById('stat-revenue');
    const dueEl = document.getElementById('stat-due-today');
    const overEl = document.getElementById('stat-overdue');
    if (revEl) revEl.textContent = sub ? formatRubShort(sub.revenue_done_this_week_rub) : '0';
    if (dueEl) dueEl.textContent = sub ? String(sub.tasks_due_today_count) : '0';
    if (overEl) {
      const v = sub ? Number(sub.tasks_overdue_count) : 0;
      overEl.textContent = String(v);
      if (v > 0) {
        overEl.classList.add('stat-overdue');
        overEl.title = `Просроченных задач: ${v}`;
      } else {
        overEl.classList.remove('stat-overdue');
        overEl.title = '';
      }
    }

    if (feverEl) {
      const zone = worstFeverZone(feverData ?? []);
      const emoji = feverEmoji(zone);
      feverEl.textContent = emoji
        ? `${emoji} ${zone}`
        : (feverData?.length ? '🟢 норма' : '—');
    }
  } catch (e) {
    if (e.message !== '401') console.warn('Stats bar failed:', e.message);
  }
}
